import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { OccTopmotiveCatalogAdapter } from './adapters/impl/occ-topmotive-catalog.adapter';
import { TopmotiveCatalogAdapter } from './adapters/topmotive-catalog.adapter';

@NgModule({ imports: [CommonModule], providers: [
        {
            provide: TopmotiveCatalogAdapter,
            useClass: OccTopmotiveCatalogAdapter,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class OccModule {}
